module.exports = __webpack_public_path__ + "img/smw-library02.f42cdb28.jpg";